import { getContextHierarchyItems } from './utils'
import { type OsContextValue } from '@wppopen/react'
import { type GtmEventSchema } from './types'
import { type MayBeNull } from '@wppopen/core/types'
import { createEventData } from './createEventData'

/**
 *
 * @param osContext - The osContext object from the WPP Open React library.
 * @description This function maps the user details from the osContext to a data layer format.
 * @returns
 */
export const getAppLaunchEventDataObject = (osContext: OsContextValue | null) => {
  const contextObject = osContext?.osContext
  const appInstance = contextObject?.appInstance
  const appCustomConfig = contextObject?.appCustomConfig as MayBeNull<Record<string, any> & AppCustomConfig> | undefined
  const hierarchyItems = getContextHierarchyItems(osContext)

  return createEventData('app_launch', osContext, {
    application_id: appInstance?.devhubAppId || 'unknown',
    application_instance_id: appInstance?.id || 'unknown',
    product_type: appInstance?.devhubMetadata.productType || 'unknown',
    nocode_apptype: appInstance?.devhubMetadata?.noCodeAppType || undefined,
    context_type: osContext ? 'os' : 'unknown',
    product_name: appCustomConfig?.product_name || 'unknown',
    product_category: appCustomConfig?.product_category || 'unknown',
    product_subcategory: appCustomConfig?.product_subcategory || 'unknown',
    project: contextObject?.project?.name || undefined,
    tenant_name: contextObject?.tenant?.name || undefined,
    ...hierarchyItems,
  }) satisfies GtmEventSchema
}
